export default "__VITE_ASSET__Dk$PC0zr__"